import React from 'react';
import { Show } from '@refinedev/antd';
import { useShow } from '@refinedev/core';
import { Tag, theme } from 'antd';
import { Field } from '../../components/Field';

interface NotificationReminderDto {
  id: string;
  code: string;
  hour: number;
  minute: number;
  actionType: string;
  title: string;
  body: string;
  translations?: Record<string, { title?: string; body?: string }> | null;
  isEnabled: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export const NotificationReminderShow: React.FC = () => {
  const { token } = theme.useToken();
  const { queryResult } = useShow<NotificationReminderDto>({
    resource: 'notification-reminders',
  });
  const item = queryResult?.data?.data;

  if (!item) {
    return <div style={{ color: token.colorTextSecondary }}>Loading...</div>;
  }

  const time = `${String(item.hour).padStart(2, '0')}:${String(item.minute).padStart(2, '0')}`;

  return (
    <Show resource="notification-reminders">
      <div style={{ padding: '8px 0' }}>
        <Field label="Code">{item.code}</Field>
        <Field label="Time">{time}</Field>
        <Field label="Action">
          <Tag>{item.actionType}</Tag>
        </Field>
        <Field label="Title (EN)">{item.title}</Field>
        <Field label="Body (EN)">{item.body}</Field>
        <Field label="Enabled">{item.isEnabled ? 'Yes' : 'No'}</Field>
        <Field label="Sort Order">{item.sortOrder}</Field>
        <Field label="Translations">
          <pre style={{ whiteSpace: 'pre-wrap' }}>
            {JSON.stringify(item.translations ?? {}, null, 2)}
          </pre>
        </Field>
        <Field label="Created At">{new Date(item.createdAt).toLocaleString()}</Field>
        <Field label="Updated At">{new Date(item.updatedAt).toLocaleString()}</Field>
      </div>
    </Show>
  );
};
